import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  Inject,
  ViewChild,
  TemplateRef,
  PLATFORM_ID,
  Renderer2,
} from '@angular/core';

import { OwlOptions } from 'ngx-owl-carousel-o';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RootService } from 'src/app/shared/services/root.service';
import { WishlistService } from 'src/app/shared/services/wishlist.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SkeletonService } from 'src/app/shared/services/skeleton.service';
import { SafePipe } from 'safe-pipe';
import { DomSanitizer } from '@angular/platform-browser';
import { setImageUrl } from '../../fni-modules/shared/helper/common_function';
import { environment } from '../../../environments/environment.prod';
import { SeoService } from '../../shared/seo/seo.service';
import { CanonicalService } from '../../shared/seo/canonical.service';
import { SlickCarouselComponent } from 'ngx-slick-carousel/slick.component';
import { resolve } from 'path';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Options } from '@angular-slider/ngx-slider';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ProductSchemaService } from '../../product-schema.service';

declare var $: any;
@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
})
export class ProductDetailComponent implements OnInit, OnDestroy {
  sub: Subscription = new Subscription();
  private safePipe1: SafePipe = new SafePipe(this.domSanitizer);
  productId: any;
  productDetailList: any;
  specificationLink: any;
  specificationList: any = [];
  pplName: any;
  plName: any;
  productPrice: any;
  isUpdatedValue: boolean = false;
  vehicleDetail: any;
  breadcrumbData: any[] = [];
  userData: any;
  isShowPopup: boolean = false;
  showWidgets: boolean = false;
  showWidgets1: boolean = false;
  preViewImg: any;
  changeallslides: boolean = false;
  newFuelType: any;
  environment1 = environment.s3bucket.url;
  isUserLoggedIn: any;
  breadcrumbdata: any = [];
  showBreadCrumb: boolean = false;
  breadcrumbList: {
    label: any;
    url: string;
    pageName: string;
  };
  selectedTerrain: string = '';

  offerData: any = [];
  productLoaded: boolean = false;
  productmetaImage: any;
  vc: any;
  priceDetail: any = [];
  pageURL: string;
  menuList = [];
  dealerLen: any = [];
  fuelProductId: any;
  fuelType: any;
  displayNames: any = [];
  removeTestDriveButton: boolean = false;
  isAMC: boolean = false;
  display: boolean = false;
  terrainvalue: boolean = false;
  form: FormGroup;
  invalidReq = false;
  // isAMC:boolean = true
  carouselOptions: OwlOptions = {
    // loop: true,
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    margin: 14,
    navText: [
      `<img alt="left" src=${this.environment1}assets/images/c-arrow-left.svg>`,
      `<img alt="right" src=${this.environment1}assets/images/c-arrow-right.svg>`,
    ],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      740: {
        items: 1,
      },
      1350: {
        items: 1,
      },
    },
    nav: true,
  };

  services = [
    {
      name: 'Platinum AMC',
      icon: 'path-to-icon',
      price: 1172800,
      numberOfCV: '1 ',
      duration: '4',
      total: 5184400,
      hasInfoBadge: true,
    },
    {
      name: 'Extended Warranty',
      icon: 'path-to-icon',
      price: 199954,
      numberOfCV: '1 ',
      duration: '4',
      total: 2999862,
      hasInfoBadge: true,
    },
    {
      name: 'Onsite Service',
      icon: 'path-to-icon',
      price: 145000,
      numberOfCV: '1 ',
      duration: '4',
      total: 1135000,
      hasInfoBadge: true,
    },
    {
      name: 'Fleet Edge plan',
      icon: 'path-to-icon',
      price: 6547,
      numberOfCV: '1 ',
      duration: '4',
      total: 19641,
      hasInfoBadge: true,
    },
  ];
  totalAmount = 9372903;
  discountAmount = 2000000;
  grandTotal = 7772903;

  metatitle = 'Buy Tata Trucks and Buses Online in India - Tata Motors';
  metadesc =
    'Enquire, book and buy online Tata Ace, Intra, Yodha Pickup, Winger, Magic, Signa, Prima, Ultra, and entire Truck, Tipper, Bus range with Tata Motors authorized dealers.';

  @ViewChild('productReview', { read: TemplateRef })
  productReview!: TemplateRef<any>;
  @ViewChild('slickHLModal') slickModal: SlickCarouselComponent;
  @ViewChild('slickModal') slickModal1: SlickCarouselComponent;
  @ViewChild('slickModal1') slickModal2: SlickCarouselComponent;
  @ViewChild('slickHLModal1') slickModal3: SlickCarouselComponent;
  offeron: string;
  lob: any;
  typeOfBooking: string;
  annualRunningHours: any;
  amcDuration: any;
  isStartedAmc: boolean = false;
  isHCV: boolean = false;
  aplicationAmcData: any;
  annual_kms: any;
  kms: any[] = [];
  amc_duration: any;
  year: any[] = [];
  amcDurationOptions: Options = {
    floor: 12,  // Minimum value
    ceil: 72,   // Maximum value (assuming based on your array of ['12', '24', '36', '48', '60', '72'])
    step: 12,
    showTicks: true,
  };
  annualRunningHoursOptions: Options = {
    floor: 1,
    ceil: 5,
    step: 1,
    showTicks: true,
  };
  currentStep: number = 1;
  terrainData: any;
  annualRunningHoursChange$ = new Subject<number>();
  amcDurationChange$ = new Subject<number>();
  amcproductData: any;
  datadismiss: boolean = false;
  terraindaata: boolean = false;
  amcDataArray = []
  vehicleTypes = [
    "Municipal – Recovery truck",
    "Bulk Mix",
    "Cement Spreader",
    "Vacuum Truck",
    "Recycler",
    "Airport Refueller",
    "Water Pumps",
    "Fire Fighter",
    "Emergency Response",
    "Recovery Trucks",
    "Concrete Bulker",
    "Skip/Hook Loader",
    "Garbage Compactor",
    "Road Sweeper",
    "Telescopic Ladders",
    "Terminal Vehicles",
    "Concrete Pumps",
    "Truck Mounted Cranes",
    "Suction Cum Jetting Pump",
    "Puller – ODC",
    "Train - Tractor",
    "Diesel Bowser",
    "Well Drill Rigs",
    "Boom Pump",
    "Crane - Truck Mounted",
    "Recovery Vehicles",
    "Sewage Suction cum jetting",
    "Dumper Placer",
    "Mobile Service Van",
    "Cash Van",
    "Mobile ATM Van",
    "Hopper Tipper",
    "Bullion Vans",
    "Cable Testing Vans",
    "Troop Carrier",
    "Riot Control",
    "Towing Vans",
  ];
  prodata: { lob: any; };
  schemeDetailList: any;
  loyalityborder: boolean = false;
  NewLob: any;
  osp_configurator_request: any;
  osp_configurator_response: any;
  vas_configurator_request: any;
  vas_configurator_response: any;
  currentRoute: any;
    isChatbotLoaded: boolean = false;
    chatbotLoaded = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private toastrService: ToastrService,
    private rootService: RootService,
    private wishlistService: WishlistService,
    private spinner: NgxSpinnerService,
    public skeletonService: SkeletonService,
    private behaviorService: BehaviourSubjectService,
    private seoservice: SeoService,
    private localStorage: secureStorage,
    private cleverService: ClevertapService,
    private domSanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object,
    private canonicalservice: CanonicalService,
    private formBuilder: FormBuilder,
    private schemaService: ProductSchemaService,private renderer: Renderer2
  ) {
    this.annualRunningHoursChange$.pipe(debounceTime(300)).subscribe((value) => {
      this.annualRunningHours = value;
      this.checkDataAvail();
      this.BookingVas();
    });

    this.amcDurationChange$.pipe(debounceTime(300)).subscribe((value) => {
      this.amcDuration = value;
      this.checkDataAvail();
      this.BookingVas();
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (isPlatformBrowser(this.platformId)) {
        const scrollPosition = window.scrollY + window.innerHeight;
      const totalHeight = document.documentElement.scrollHeight;
  
      if (scrollPosition >= totalHeight / 2 && !this.chatbotLoaded) {
        console.log("User scrolled halfway, loading chatbot...");
        this.loadScript();
        this.chatbotLoaded = true;
      }
      if (
        document.body.scrollTop > 300 ||
        document.documentElement.scrollTop > 300
      ) {
        $('.scroll-details-menu').removeClass('d-none');
      } else {
        $('.scroll-details-menu').addClass('d-none');
      }
    }
  }

  imageSlider = {
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    dots: true,
    autoplay: false,
    draggable: false,
    prevArrow: '.client-feedback .prev-arrow',
    nextArrow: '.client-feedback .next-arrow',
    asNavFor: '.thumbs,.popimagepreview,.popimgthumbs',
  };
  thumbSlider = {
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    asNavFor: '.imagepreview,.popimagepreview,.popimgthumbs',
    dots: false,
    autoplay: false,
    draggable: true,
    focusOnSelect: true,
    prevArrow: '.client-thumbnails .prev-arrow',
    nextArrow: '.client-thumbnails .next-arrow',
    vertical: true,
  };
  popthumbSlider = {
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.popimagepreview',
    dots: false,
    autoplay: false,
    draggable: true,
    focusOnSelect: true,
    vertical: false,
    arrows: false,
  };
  popimageSlider = {
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    dots: false,
    autoplay: false,
    draggable: false,
    prevArrow: '.client-feedback .prev-arrow',
    nextArrow: '.client-feedback .next-arrow',
    asNavFor: '.popimgthumbs',
  };
  offerOption: OwlOptions = {
    // loop: true,
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    margin: 14,
    navText: [
      `<img alt="left" src=${this.environment1}assets/images/c-arrow-left.svg>`,
      `<img alt="right" src=${this.environment1}assets/images/c-arrow-right.svg>`,
    ],
    responsive: {
      0: {
        items: 3,
      },
      400: {
        items: 3,
      },
      740: {
        items: 3,
      },
      1350: {
        items: 3,
      },
    },
    nav: true,
  };
  schemeDealeCodes = ['1009590','1009460', '1001850','100B780','1007960','1009061','1001770','1009050','1009000','1000480','1008870', '1002600','100B710','100A150','1004850','100B540','1003530']

  lobSeo: string;
  subLob: string;
  pplSeo: string;
  model: string;
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('rewardTermsCondition');
      localStorage.removeItem('tat_id');
      localStorage.setItem('catIdid', 'false')
      localStorage.removeItem('quantity')
      localStorage.removeItem('VASData')
      this.behaviorService.isSmart.next(false);
      this.behaviorService.offerdetailsvisible.next(true);
      localStorage.setItem('isproductdetail', 'yes');
      localStorage.removeItem('productOfferData');
      localStorage.removeItem('currentRoute');
    }
    this.currentRoute = this.router.url
    this.pageURL = window.location.href;
    if (this.pageURL.includes('scv-pickups'))
      this.removeTestDriveButton = true;

    try {
      this.cleverService.onPageView('Product Detail');
    } catch { }
    this.sub.add(
      this.behaviorService.isLoggedIn.subscribe(() => {
        this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
        this.userData = this.rootService.getUserData();
      })
    );
    this.activatedRoute.paramMap.subscribe((params) => {
      if (params.get('id')) {
        this.productId = params.get('id');
        this.breadcrumbData = [
          params.get('lob_seo'),
          params.get('sub_lob'),
          params.get('ppl_seo'),
          params.get('model'),
        ];
        this.lobSeo = params.get('lob_seo');
        this.subLob = params.get('sub_lob');
        this.pplSeo = params.get('ppl_seo');
        this.model = params.get('model');
        this.getVehicleDetail(this.productId);
        this.getSpecificationValueList();
      }
    });
    this.sub.add(
      this.activatedRoute.queryParams.subscribe(async (params) => {
        if (params['dealer']) {
          if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem('myObject');
            localStorage.setItem('dealercd', params['dealer']);
            localStorage.setItem('vc', params['vc']);
            this.vc = params['vc'];
          }
          this.getDealer();
          this.getVehicleDetail(this.productId);
          this.getSpecificationValueList();
        }

        if (isPlatformBrowser(this.platformId)) {
          let myObject = {
            source: await params['utm_source'],
            medium: await params['utm_medium'],
            campaign:
              (await params['utm_campaign']) || params['utm_campaignname'],
            campaign_id: await params['gclid'],
          };
          this.localStorage.setItem('myObject', JSON.stringify(myObject));
        }
      })
    );
    this.form = this.formBuilder.group({
      model: [
        { value: '', disabled: !this.typeOfBooking },
        [Validators.required, Validators.maxLength(45)],
      ],
      vehicles: ['1',
        [Validators.required, Validators.max(99), Validators.min(1)],
      ],
      application: ['', Validators.required],
      terrain: ['', Validators.required],
      range1: [
        this.annualRunningHours ? this.annualRunningHours.toString() : '',
        Validators.required,
      ],
      range2: [
        this.amcDuration ? this.amcDuration.toString() : '',
        Validators.required,
      ],
    });

    this.behaviorService.getAmcDataflow.subscribe((value) => {
      if (value) {
        this.bookNow();
      }
    });
    if (isPlatformBrowser(this.platformId)) {
      let dealercdforloyality = localStorage.getItem('dealercd');
      // this.loyalityborder = this.schemeDealeCodes.includes(dealercdforloyality) ? true : false
    }
  }

  updateProductSchema() {
    const productSchema = {
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": this.productDetailList?.pl,
      "image": this.productDetailList?.images[0]?.image_url,
      "description": this.productDetailList?.product_description,
      "brand": {
        "@type": "Brand",
        "name": "Tata Motors"
      },
      "sku": "",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4",
        "bestRating": "4",
        "worstRating": "1",
        "ratingCount": "14"
      }
    };

    this.schemaService.injectSchema(productSchema);
  }
  getDealer() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('dealername');
      {
        let data = {
          dealer_code: localStorage.getItem('dealercd'),
          action_type: 'dropdown',
        };
        this.sub.add(
          this.apiService.getDealerList(data).subscribe({
            next: (response: any) => {
              if (response['success']) {
                this.dealerLen = response?.data;
                localStorage.setItem(
                  'dealername',
                  this.dealerLen[0].division_name +
                  '_' +
                  this.dealerLen[0].dealer_code
                );
                this.behaviorService.dealerName.next(true);
              }
            },
            error: (error) => {
              this.toastrService.warning(error.data.msg);
            },
            complete: () => { },
          })
        );
      }
    }
  }
  nextSlide() {
    this.slickModal.slickNext();
    this.slickModal1.slickNext();
    this.slickModal2.slickNext();
    this.slickModal3.slickNext();
  }
  nextSlide1() {
    this.slickModal3.slickNext();
  }
  prevSlide() {
    this.slickModal.slickPrev();
    this.slickModal1.slickPrev();
    this.slickModal2.slickPrev();
    this.slickModal3.slickPrev();
  }
  prevSlide1() {
    this.slickModal2.slickPrev();
    this.slickModal3.slickPrev();
  }

  getVehicleDetail(id: any) {
    let data;
    if (this.vc) {
      data = {
        vehicle_number: this.vc,
      };
    } else {
      data = {
        product_id: id ? id : this.fuelProductId,
      };
    }
    this.sub.add(
      this.apiService.getVehicleDetails(data).subscribe({
        next: (res: any) => {
          this.productDetailList = res?.data;
          this.updateProductSchema()
          let lobValue;
          switch (this.productDetailList?.lob) {
            case 'hcv-const':
            case 'hcv-cargo':
            case 'HCV Const':
            case 'HCV Cargo':
              lobValue = 'hcv';
              break;
            case 'bus':
            case 'BUSES':
            case 'Buses':
              lobValue = 'bus';
              break;
            case 'magic':
              lobValue = 'tata_magic';
              break;
            case 'winger':
            case 'SCPASS':
              lobValue = 'winger';
              break;
            case 'hcv':
              lobValue = 'hcv';
              break;
            case 'ilmcv':
              lobValue = 'ilmcv';
              break;
            case 'scv':
            case 'SCV CARGO':
              lobValue = 'scv';
              break;
            case 'ScPass':
              lobValue = 'winger';
              break;
            case 'SCVPass':
              lobValue = 'tata_magic';
              break;
            case 'SCV Cargo':
              lobValue = 'scv';
              break;
            case 'Pickups':
            case 'PICKUPS':
            case 'Yodha & Intra':
              lobValue = 'scv';
              break;
            case 'mcv-trucks':
            case 'icv':
            case 'mhcv':
            case 'MCV Trucks':
            case 'ICV Trucks':
            case 'LCV':
              lobValue = 'ilmcv';
              break;
            default:
              lobValue = this.productDetailList?.lob;
              break;
          }
          this.NewLob = lobValue;
          if(this.productDetailList.product_url)
            this.canonicalservice.createCanonicalURL(this.productDetailList.product_url);
          else
          setTimeout(() => {
        this.canonicalservice.createCanonicalURL(this.productDetailList.product_url);
          }, 1000);
        
          if (this.productDetailList.images?.length > 5) {
            this.popthumbSlider.slidesToScroll = 1;
          } else {
            this.popthumbSlider.slidesToScroll = 5;
          }

          this.productLoaded = true;
          this.getPriceValueList();
          this.breadcrumb();
          this.lob = this.productDetailList?.lob;
          this.pplName = this.productDetailList?.ppl;
          this.plName = this.productDetailList?.pl;
          this.productPrice = this.productDetailList?.price_range;
          if (this.productDetailList?.vehicle_number) {
            this.getSchemeDetail(this.productDetailList?.vehicle_number);
          }
          this.menuList = [];
          if (this.productPrice) {
            this.menuList = [
              {
                name: 'Specification',
                routeURL: 'specification',
                isActive: true,
              },
              { name: 'Comparision', routeURL: 'comparision', isActive: false },
              { name: 'Reviews', routeURL: 'reviews', isActive: false },
            ];
            let value = {
              name: 'EMI Calculator',
              routeURL: 'emi',
              isActive: false,
            };
            this.menuList.splice(1, 0, value);
          } else {
            this.menuList = [
              {
                name: 'Specification',
                routeURL: 'specification',
                isActive: true,
              },
              { name: 'Comparision', routeURL: 'comparision', isActive: false },
              { name: 'Reviews', routeURL: 'reviews', isActive: false },
            ];
          }
          this.vehicleDetail = res;
          this.isUpdatedValue = true;
          this.productmetaImage = this.productDetailList['images'][0].image_url;

          this.metatitle = this.productDetailList.vc_title
            ? this.productDetailList.vc_title
            : 'Tata Motors Online Sales';
          this.metadesc = this.productDetailList.vc_description
            ? this.productDetailList.vc_description
            : ' ';

          if (this.productDetailList['images']) {
            if (this.productDetailList['images'].image_url) {
              this.productmetaImage =
                this.productDetailList['images'].image_url;
            } else {
              this.productDetailList.images
                .filter((image) => image.is_cover === true)
                .map((img) => {
                  this.productmetaImage = img['image_url'];
                });
            }
          }
          if (this.productDetailList.ppl && this.productDetailList.lob) {
            this.getFuelTypeData(
              this.productDetailList.ppl,
              this.productDetailList.lob,
              this.productDetailList.fuel_type
            );
            this.fuelType = this.productDetailList.fuel_type;
          }

          this.getOffer();
          if (!this.rootService.getUserData()) {
            let wishList: any = [];
            wishList = this.wishlistService.getWishlist();
            if (wishList?.length > 0) {
              wishList?.forEach((el: any) => {
                if (el == this.productDetailList.id) {
                  this.productDetailList.wishlist = true;
                }
              });
            }
          }
          this.clevertap();
        },
        error: () => {
          this.productLoaded = true;
        },
        complete: () => {
          this.seo();
        },
      })
    );
  }

  async bookNow(val?,tat?) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem("VASData")
      if (this.datadismiss == true) {
        let vasSelectedData = {
          AnnualKms: Math.floor(this.form.controls['range1'].value / 12),
          Exshowroomprice: this.productDetailList?.price_range, // need to confirm
          LOB: this.productDetailList?.lob,
          NoOfyears: Math.floor(this.form.controls['range2'].value.toString() / 12),
          SubLob: this.productDetailList?.sub_lob,
          VASBookingAmount: (this.productDetailList.sub_lob == "scv-cargo" || this.productDetailList.sub_lob == "pickups" || this.productDetailList.sub_lob == "scv-pickups" || this.productDetailList.sub_lob == "scvpass" || this.productDetailList.sub_lob == "scpass") ? 1000 : 2000,
          VASPLAN: this.amcDataArray,
          VASTotalAmount: this.calculateTotalAmountperyear(this.amcDataArray),
          VCNUMBER: this.productDetailList?.vehicle_number,
          VasAvailable: "YES",
          crmApplication: '',
          fuel_type: this.productDetailList?.fuel_type ? this.productDetailList?.fuel_type : "", // need to ask
          isViaConfigurator: true,
          isViaOSPVas: true,
          openPage: "booking",
          taggedVC: [],
          terrian: this.form.controls['terrain'].value,
          vasApplication: this.form.controls['application'].value.actual_application,
          recommended_quantity: this.form.controls['vehicles'].value,
        }
        this.localStorage.setItem('VASData', JSON.stringify(vasSelectedData));
      }
      if (tat == true) {
        try {
          await this.vastatrequestresponsereturn(); // Wait for API response
        } catch (error) {
          console.error("Error in vastatrequestresponse:", error);
        }
      }

      if (this.isUserLoggedIn) {
        let sublob =
          this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'icv-trucks'
            ? 'trucks'
            : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
              'buses'
              ? 'buses-vans'
              : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase();
        let model = this.productDetailList.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
        this.router.navigate([
          '/lead-booking/' +
          sublob +
          '/' +
          this.productDetailList.lob_seo +
          '/' +
          this.productDetailList.ppl_seo +
          '/' +
          model +
          '/' +
          this.productDetailList.id,
        ]);
      } else {
        let sublob =
          this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'icv-trucks'
            ? 'trucks'
            : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
              'buses'
              ? 'buses-vans'
              : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase();
        let model = this.productDetailList.model
          .replace(/\s/g, '-')
          .replace(/\//g, '-')
          .replace(/\+/g, '-')
          .replace(/\./g, '-')
          ?.toLowerCase();

        localStorage.setItem(
          'previousUrl',
          '/lead-booking/' +
          sublob +
          '/' +
          this.productDetailList.lob_seo +
          '/' +
          this.productDetailList.ppl_seo +
          '/' +
          model +
          '/' +
          this.productDetailList.id
        );
        this.router.navigate(['/login/']);
      }

    }
    this.clevertapBook(this.productDetailList);
  }

  clevertapBook(productDetailsData: any) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onBookNowButtonClick(
          productDetailsData['id'],
          productDetailsData['model'],
          productDetailsData['images'][0].image_url,
          'Top Navigation'
        );
      } catch { }
    }
  }
  imagePreviewpopup() {
    $('#imageFullScreenModeModal').modal('show', function () { });
    $('#imageFullScreenModeModal').on('shown.bs.modal', function () {
      $('.gallery').slick('setPosition');
      $('.gallery2').slick('setPosition');
    });
  }

  imagePreviewpopupClose() {
    $('#imageFullScreenModeModal').modal('hide');
  }
  openSocialSharePopup() {
    $('#socialShareModal').modal('show', function () { });
  }
  closeSocialSharePopup() {
    $('#socialShareModal').modal('hide');
  }

  bootTestDrive() {
    this.userData = this.rootService.getUserData();
    let sublob =
      this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
        'icv-trucks'
        ? 'trucks'
        : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
          'buses'
          ? 'buses-vans'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase();
    let model = this.productDetailList.model
      .replace(/\s/g, '-')
      .replace(/\//g, '-')
      .replace(/\+/g, '-')
      .replace(/\./g, '-')
      ?.toLowerCase();

    var url =
      '/book-test-drive/' +
      sublob +
      '/' +
      this.productDetailList.lob_seo +
      '/' +
      this.productDetailList.ppl_seo +
      '/' +
      model +
      '/' +
      this.productDetailList.id;
    if (this.isUserLoggedIn) {
      this.router.navigate([
        '/book-test-drive/' +
        sublob +
        '/' +
        this.productDetailList.lob_seo +
        '/' +
        this.productDetailList.ppl_seo +
        '/' +
        model +
        '/' +
        this.productDetailList.id,
      ]);
    } else {
      if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem('previousUrl', url);
      }
      this.router.navigate(['/login/']);
    }
  }

  clickToAddWishlist(event: any) {
    if (this.rootService.getUserData()) {
      for (let e = 0; e < this.productDetailList?.length; e++) { }
      if (this.productDetailList.id == event) {
        if (this.productDetailList.wishlist == false) {
          this.productDetailList.wishlist = true;
          this.addToWishlist(event, 'add');
          return;
        }
        if (this.productDetailList.wishlist == true) {
          this.productDetailList.wishlist = false;
          this.addToWishlist(event, 'delete');
          return;
        }
      }
    } else {
      if (this.productDetailList.id == event) {
        this.productDetailList.wishlist = !this.productDetailList.wishlist;
      }
      this.wishlistService.addItemToWishList(event);
      let wishList: any = [];
      wishList = this.wishlistService.getWishlist();
      wishList.forEach((el: any) => {
        for (let i = 0; i < this.productDetailList?.length; i++) {
          if (el == this.productDetailList[i].id) {
            this.productDetailList.wishlist = true;
          } else {
            this.productDetailList.wishlist = false;
          }
        }
      });
    }
  }

  addToWishlist(event: any, type: any) {
    let data;
    if (type == 'add') {
      data = {
        product: [event],
        action_type: 'add',
      };
    } else {
      data = {
        action_type: 'delete',
        product_list: [event],
      };
    }
    this.sub.add(
      this.apiService.addToWishlist(data).subscribe({
        next: (res: any) => {
          if (type == 'add') {
            this.toastrService.success(res.data.msg);
            this.productDetailList.forEach((e: any) => {
              if (e.id == event) {
                e.wishlist = true;
                return;
              }
            });
          } else {
            this.toastrService.warning(res.data.msg);
          }
        },
        error: () => { },
        complete: () => { },
      })
    );
  }

  clickOnWidget() {
    this.showWidgets = true;
  }
  closeidget() {
    this.showWidgets = false;
  }
  clickOnWidget1() {
    this.showWidgets1 = true;
  }
  closeidget1() {
    this.showWidgets1 = false;
  }

  clickToScroll(element: any) {
    var value: any;
    value = document.getElementById(element);

    this.menuList.map(function (data) {
      data.isActive = data.routeURL === element;
    });

    value.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  breadcrumb() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('sideFilter');
      localStorage.removeItem("ExploreMappedData")
      localStorage.removeItem("ExploreMappedData1")
      localStorage.removeItem("explore")
      localStorage.removeItem("EModeldData")
      localStorage.removeItem('ExploreMappedDatatype')
      localStorage.removeItem('ExploreMappedDatamodal')
      localStorage.removeItem('localBreadCrumb');
    }
    this.breadcrumbList = {
      label:
        this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
          'icv-trucks'
          ? 'Trucks'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'buses'
            ? 'Buses & Vans'
            : this.productDetailList.sub_lob,
      url:
        `/product-list/` +
        (this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
          'icv-trucks'
          ? 'trucks'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'buses'
            ? 'buses-vans'
            : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase()),
      pageName: 'product-details',
    };

    this.breadcrumbdata.push(this.breadcrumbList);

    this.breadcrumbList = {
      label: this.productDetailList.lob,
      url:
        `/category-list/` +
        (this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
          'icv-trucks'
          ? 'trucks'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'buses'
            ? 'buses-vans'
            : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase()) +
        `/` +
        this.productDetailList.lob?.replace(/\s/g, '-')?.toLowerCase(),
      pageName: 'product-details',
    };
    this.breadcrumbdata.push(this.breadcrumbList);

    this.breadcrumbList = {
      label: this.productDetailList.ppl,
      url:
        `/product-list/` +
        (this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
          'icv-trucks'
          ? 'trucks'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'buses'
            ? 'buses-vans'
            : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase()) +
        `/` +
        this.productDetailList.lob?.replace(/\s/g, '-')?.toLowerCase() +
        `/` +
        this.productDetailList.ppl
          ?.replace(/\s/g, '-')
          .replace('---', '-')
          .replace('/', '-')
          ?.toLowerCase(),
      pageName: 'product-list',
    };
    this.breadcrumbdata.push(this.breadcrumbList);

    this.breadcrumbList = {
      label: this.productDetailList.model,
      url: '',
      pageName: 'product-details',
    };
    this.breadcrumbdata.push(this.breadcrumbList);
    if (isPlatformBrowser(this.platformId)) {
      this.localStorage.setItem(
        'localBreadCrumb',
        JSON.stringify(this.breadcrumbdata)
      );
    }
    this.showBreadCrumb = true;
    this.seoservice.callSchema();
  }

  getOffer() {
    let data = {
      noOfCampaignOffers: 10,
      lob: this.lob ? this.lob : '',
      ppl: this.pplName ? this.pplName : '',
      pl: this.plName ? this.plName : '',
      state: this.userData.state ? this.userData.state : '',
      sortBy: 'campaignSchemePriority',
      sortOrder: 'asc',
      offset: 0,
    };
    this.sub.add(
      this.apiService.getOffersDetailsNew(data).subscribe({
        next: (res: any) => {
          this.offerData = res.offers;
        },
        error: () => { },
        complete: () => { },
      })
    );
  }

  setFinancierImgUrl(financierId: any) {
    return setImageUrl(financierId);
  }

  getSpecificationValueList() {
    if (isPlatformBrowser(this.platformId)) {
      try {
        if (localStorage.getItem('specificationList')) {
          this.specificationList = JSON.parse(
            localStorage.getItem('specificationList')
          );
        }
        if (!localStorage.getItem('specificationList')) {
          this.sub.add(
            this.apiService.getS3Data('specification_img.txt').subscribe({
              next: (response: any) => {
                this.spinner.show();
                if (response.success) {
                  this.specificationList = response.data.SpecificationList;
                  localStorage.setItem(
                    'specificationList',
                    JSON.stringify(this.specificationList)
                  );
                  this.spinner.hide();
                } else {
                  this.specificationList = [];
                  localStorage.removeItem('specificationList');
                  this.toastrService.warning(response.data.msg);
                  this.spinner.hide();
                }
              },
              error: () => {
                this.spinner.hide();
              },
              complete: () => { },
            })
          );
        }
      } catch (error) { }
    }
  }

  moveToOfferList() {
    if (isPlatformBrowser(this.platformId)) {
      this.localStorage.setItem(
        'productOfferData',
        JSON.stringify(this.productDetailList)
      );
      let model = this.productDetailList.model;
      let sublob =
        this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
          'icv-trucks'
          ? 'trucks'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'buses'
            ? 'buses-vans'
            : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase();
      localStorage.setItem(
        'previousUrl',
        this.productDetailList.lob +
        ',' +
        this.productDetailList.ppl +
        ',' +
        this.productDetailList.pl +
        ',' +
        this.productDetailList.model
      );
    }
  }

  navigateToOfferDetail(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.productDetailList.financierId = data.tmlSchemeID;
      this.productDetailList.financierName =
        data.financierDetails.crmFinancierName;
      this.localStorage.setItem(
        'productOfferData',
        JSON.stringify(this.productDetailList)
      );
      this.router.navigate(['offer-details'], {
        queryParams: { financierSchemeId: data.financierSchemeId },
      });
    }
  }

  seo() {
    this.seoservice.updateTitle(this.metatitle);
    this.seoservice.updateMetaTag('description', null, this.metadesc);
    this.seoservice.updateMetaTag(null, 'og:locale', 'en_US');
    this.seoservice.updateMetaTag(null, 'og:type', 'Website');
    this.seoservice.updateMetaTag(null, 'og:title', this.metatitle);
    this.seoservice.updateMetaTag(null, 'og:description', this.metadesc);
    this.seoservice.updateMetaTag(
      null,
      'og:url',
      environment.baseUrl + this.router.url
    );
    this.seoservice.updateMetaTag(null, 'og:site_name', 'Tata OSP');
    this.seoservice.updateMetaTag(
      null,
      'og:image',
      this.productmetaImage ? this.productmetaImage : ' '
    );
    this.seoservice.updateMetaTag(null, 'og:image:width', '1200');
    this.seoservice.updateMetaTag(null, 'og:image:height', '628');
  }

  clevertap() {
    let sublob =
      this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
        'icv-trucks'
        ? 'trucks'
        : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
          'buses'
          ? 'buses-vans'
          : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase();
    let model = this.productDetailList.model
      .replace(/\s/g, '-')
      .replace(/\//g, '-')
      .replace(/\+/g, '-')
      .replace(/\./g, '-')
      ?.toLowerCase();
    let url =
      '/lead-booking/' +
      sublob +
      '/' +
      this.productDetailList.lob_seo +
      '/' +
      this.productDetailList.ppl_seo +
      '/' +
      model +
      '/' +
      this.productDetailList.id;
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onProductViewDetails(
          this.productDetailList['id'],
          this.productDetailList['model'],
          this.productmetaImage,
          'Top Navigation',
          this.productDetailList['sub_lob'],
          this.productDetailList['lob'],
          this.productDetailList['ppl'],
          this.productDetailList['price_range']
            ? this.productDetailList['price_range']
            : '',
          this.productDetailList['down_payment'],
          '',
          '',
          '',
          '',
          window.location.origin + url,
          url
        );
      } catch (error) { }
    }
  }

  getPriceValueList() {
    this.priceDetail = [];
    try {
      this.sub.add(
        this.apiService.getS3Data('price.txt').subscribe({
          next: (response: any) => {
            this.priceDetail = response.data.data.filter(
              (element: any) =>
                element.vc == this.productDetailList['vehicle_number']
            );
          },
          error: () => {
            this.spinner.hide();
          },
          complete: () => { },
        })
      );
    } catch (error) { }
  }

  copyMessage() {
    this.toastrService.success('Link copied.');
    navigator.clipboard.writeText(this.pageURL);
  }

  changeslide(n) {
    if (this.changeallslides) {
      this.slickModal.slickGoTo(n);
    }
  }

  getFuelTypeData(ppl, lob, fuelType) {
    let data = {
      ppl: ppl,
      lob: lob,
    };
    this.sub.add(
      this.apiService.getFuelType(data).subscribe({
        next: (res) => {
          if (res.success) {
            this.newFuelType = res.data;
            this.newFuelType.map(function (data) {
              data.checked = data.fuel_type === fuelType;
            });
          }
        },
      })
    );
  }

  changeFuel(value: any) {
    this.fuelProductId = '';
    this.fuelType = '';
    this.newFuelType.forEach((element: any) => {
      this.changeallslides = true;
      if (element.fuel_type == value) {
        this.fuelProductId = element.id;
        this.fuelType = this.productDetailList.fuel_type;
        // this.getVehicleDetail(this.productDetailList.id)
        let sublob =
          this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'icv-trucks'
            ? 'trucks'
            : this.productDetailList.sub_lob
              .replace(/\s/g, '-')
              ?.toLowerCase() == 'buses'
              ? 'buses-vans'
              : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase();
        let model = this.productDetailList.model
          .replace(/\s/g, '-')
          .replace(/\//g, '-')
          .replace(/\+/g, '-')
          .replace(/\./g, '-')
          ?.toLowerCase();
        this.router.navigate([
          '/product-details/' +
          sublob +
          '/' +
          this.productDetailList.lob_seo +
          '/' +
          this.productDetailList.ppl_seo +
          '/' +
          model +
          '/' +
          this.fuelProductId,
        ]);
      }
    });
  }
  goToamc(data): void {
    if (this.form.valid) {
      const formData = this.form.value;
      this.confirmData(data);
    }
  }


  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  fetchAmcData(data: any) {
    this.isAMC = false;
    this.sub.add(
      this.apiService.getAMCData(data).subscribe({
        next: (response: any) => {
          if (response.STATUS == 'SUCCESS') {
            const amcData = response.RESPONSE.DATA;
            this.isAMC = amcData?.amc_type?.length > 0;
            if (this.isAMC) {
              const btn = document.getElementById('booking_amcbtn');
              if (btn) {
                btn.click();
              }
            } else {
              this.bookNow()
            }
          } else {
            this.isAMC = false;
            this.bookNow()
          }
        },
        error: () => {
          this.isAMC = false;
        },
        complete: () => { },
      })
    );
  }

  checkbook() {
    const excludedUrlPattern = '/booking-amc-list/';

    if (this.isAMC) {
      const btn = document.getElementById('booking_amcbtn');
      if (btn) {
        btn.click();
      }
    }
  }

  applicationAMC() {
    try {
      // this.spinner.show()
      const specificPlValues = [
        'SIGNA 4830.TK.',
        'SIGNA 4830.TK. FBV',
        'SIGNA 4825.TK.',
        'SIGNA 4230.TK.'
      ];

      this.prodata = (this.productDetailList.lob === 'HCV Const' && specificPlValues.includes(this.productDetailList.pl))
        ? { lob: "HCV Cargo" }
        : { lob: this.productDetailList?.lob };

      this.sub.add(
        this.apiService.amcAplicationData(this.prodata).subscribe({
          next: (response: any) => {
            // this.spinner.hide();
            if (response) {
              this.aplicationAmcData = response?.data?.vasrecappl_data;
              this.terraindaata = false;
              // this.terrainAMCData();
            } else {
              this.isAMC = false;
            }
          },
          error: () => {
            this.isAMC = false;
            this.spinner.hide()
          },
          complete: () => {
            // this.spinner.hide()
          },
        })
      );
    } catch (error) {
      this.spinner.hide()
    }
  }

  terrainAMCData(event: any) {
    const selectedValue = this.form.controls['application'].value?.display_application;
    this.terraindaata = false;
    if ((this.productDetailList.lob === 'HCV Const' || this.productDetailList.lob === 'HCV Cargo' || this.productDetailList.lob === 'ICV Trucks' || this.productDetailList.lob === 'LCV' || this.productDetailList.lob === 'MCV Trucks') && this.vehicleTypes.includes(selectedValue)) {
      this.terraindaata = true;
      this.terrainvalue = true
      this.spinner.hide();
      return;
    }

    this.spinner.show()
    try {
      let data = {
        application: this.form.controls['application'].value.actual_application,
        output_type: 'terrain',
        vc_no: this.productDetailList?.vehicle_number,
        pl: this.productDetailList?.pl,
        lob_name: this.NewLob?.toLowerCase()
      };
      this.sub.add(
        this.apiService.getAMCData(data).subscribe({
          next: (response: any) => {
            this.spinner.hide();
            if (response.STATUS == 'SUCCESS') {
              this.form.controls['terrain'].setValue('');
              this.terrainData = [];
              this.terrainData = response.RESPONSE.DATA.terrain;
              if (response.STATUS == 'SUCCESS' && this.terrainData?.length <= 0) {
                this.terrainvalue = true
              } else {
                this.terrainvalue = false
              }
              // this.sliderdata()
            } else {
              this.isAMC = false;
            }
          },
          error: () => {
            this.isAMC = false;
            this.spinner.hide()
          },
          complete: () => {
            this.spinner.hide()
          },
        })
      );
    } catch (error) {
      this.spinner.hide()
    }
  }
  sliderdata() {
    try {
      this.spinner.show()
      let data = {
        output_type: 'all',
        vc_no: this.productDetailList?.vehicle_number,
        terrain: this.form.controls['terrain'].value,
        application: this.form.controls['application'].value.actual_application,
        pl: this.productDetailList?.pl,
        lob_name: this.NewLob?.toLowerCase()
      };

      this.sub.add(
        this.apiService.getAMCData(data).subscribe({
          next: (response: any) => {
            this.spinner.hide()
            if (response.STATUS === 'SUCCESS') {
              this.annual_kms = response.RESPONSE.DATA.map(
                (element) => element.annual_kms
              );
              this.amc_duration = response.RESPONSE.DATA.map(
                (element) => element.amc_duration
              );

              this.kms = [...new Set(this.annual_kms)].sort(
                (a, b) => Number(a) - Number(b)
              );
              this.year = [...new Set(this.amc_duration)].sort(
                (a, b) => Number(a) - Number(b)
              );

              this.annualRunningHoursOptions = {
                floor: Math.min(...this.kms),
                ceil: Math.max(...this.kms),
                showTicksValues: true,
                translate: (value: number): string => {
                  return Math.round(value).toString();
                },
              };

              this.amcDurationOptions = {
                floor: Math.min(...this.year),
                ceil: Math.max(...this.year),
                showTicksValues: true,
                translate: (value: number): string => {
                  return value / 12 + '';
                },
              };

              this.annualRunningHours = this.kms[0];
              this.amcDuration = this.year[0];
              this.generateStepsArraykms();
              this.generateStepsArray();
              this.BookingVas();
              if (response.RESPONSE.DATA?.length > 0) {
                this.display = true
              } else {
                this.display = false
              }

            } else {
              this.isAMC = false;
            }
          },
          error: (error) => {
            this.spinner.hide()
            this.isAMC = false;
            console.error('API Error:', error);
          },
          complete: () => { },
        })
      );
    } catch (error) {
      console.error('Sliderdata Error:', error);
    }
  }

 async confirmData(data1) {
    try {
      // this.spinner.show()
      let data = {
        output_type: 'all',
        application: this.form.controls['application'].value.actual_application,
        terrain: this.form.controls['terrain'].value,
        vc_no: this.productDetailList.vehicle_number,
        amc_duration: this.form.controls['range2'].value.toString(),
        annual_kms: this.form.controls['range1'].value.toString(),
        pl: this.productDetailList?.pl,
        lob_name: this.NewLob?.toLowerCase()
      };
      this.sub.add(
        this.apiService.getAMCData(data).subscribe({
          next: async (response: any) => {
            // this.spinner.hide();
            if (response.STATUS == 'SUCCESS') {
              if (response?.RESPONSE?.DATA?.length > 0) {
                this.invalidReq = false;
                localStorage.removeItem('amcPlan');
                let amcData = [];
                amcData = response.RESPONSE.DATA;
                if (data1 == true) {
                  try {
                    await this.vastatrequestresponse(); // Wait for API response
                  } catch (error) {
                    console.error("Error in vastatrequestresponse:", error);
                  }
                }
              
                // this.translate();
                let sublob =
                  this.productDetailList.sub_lob
                    .replace(/\s/g, '-')
                    ?.toLowerCase() == 'icv-trucks'
                    ? 'trucks'
                    : this.productDetailList.sub_lob
                      .replace(/\s/g, '-')
                      ?.toLowerCase() == 'buses'
                      ? 'buses-vans'
                      : this.productDetailList.sub_lob
                        .replace(/\s/g, '-')
                        ?.toLowerCase();
                let model = this.productDetailList.model
                  .replace(/\s/g, '-')
                  .replace(/\//g, '-')
                  .replace(/\+/g, '-')
                  .replace(/\./g, '-')
                  ?.toLowerCase();
                let applicat = this.form.controls['application'].value.actual_application?.replace(
                  /-/g,
                  '#'
                );
                let applicatin = applicat.replace(/\//g, '-');
                let terrain = this.form.controls['terrain'].value.replace(
                  /\//g,
                  '-'
                );
                this.router.navigate([
                  '/booking-amc-list/' +
                  sublob +
                  '/' +
                  this.productDetailList.lob_seo +
                  '/' +
                  this.productDetailList.ppl_seo +
                  '/' +
                  model +
                  '/' +
                  this.productDetailList.id +
                  '/' +
                  this.productDetailList.vehicle_number +
                  '/' +
                  applicatin +
                  '/' +
                  terrain +
                  '/' +
                  this.form.controls['range2'].value +
                  '/' +
                  this.form.controls['range1'].value,
                ]);
                localStorage.setItem('quantity', this.form.controls['vehicles'].value,)
              } else {
                this.invalidReq = true;
              }
            } else {
              this.invalidReq = true;
            }
          },
        })
      );
    } catch (error) { }
  }
  checkDataAvail() {
    try {
      // this.spinner.show()
      let data = {
        output_type: 'all',
        application: this.form.controls['application'].value.actual_application,
        terrain: this.form.controls['terrain'].value,
        vc_no: this.productDetailList.vehicle_number,
        amc_duration: this.form.controls['range2'].value.toString(),
        annual_kms: this.form.controls['range1'].value.toString(),
        pl: this.productDetailList?.pl,
        lob_name: this.NewLob
      };
      this.osp_configurator_request = data;
      this.sub.add(
        this.apiService.getAMCData(data).subscribe({
          next: (response: any) => {
            this.osp_configurator_response = response;
            if (response.STATUS == 'SUCCESS') {
              this.spinner.hide()
              if (response?.RESPONSE?.DATA?.length > 0) {
                this.invalidReq = false;
              } else {
                this.invalidReq = true;
              }
            } else {
              this.invalidReq = true;
            }
          },
        })
      );
    } catch (error) {
      // this.spinner.hide()
    }
  }

  generateStepsArray(): void {
    this.amcDurationOptions.stepsArray = this.year.map((value) => {
      return { value };
    });
    // this.BookingVas();

  }

  generateStepsArraykms(): void {
    this.annualRunningHoursOptions.stepsArray = this.kms.map((value) => {
      return { value };
    });
    //  this.BookingVas();

  }

  onAnnualRunningHoursChange(event: number): void {
    this.annualRunningHours = event;
    this.annualRunningHoursChange$.next(event);

    // this.BookingVas();
  }

  onAmcDurationChange(event: number): void {
    this.amcDuration = event;
    this.amcDurationChange$.next(event);

    // this.BookingVas();
  }

  checkAmcData() {
    localStorage.removeItem('tat_id');
    localStorage.removeItem('schemeCode');
    try {
      const data = {
        output_type: 'amc_type',
        vc_no: this.productDetailList?.vehicle_number,
        pl: this.productDetailList?.pl,
        lob_name: this.NewLob?.toLowerCase()
      };
      this.fetchAmcData(data);
      // );
    } catch (error) {
      console.error('Error in checkAmcData:', error);
    }
  }

  onTerrainChange(event: Event) {
    this.sliderdata();
    const target = event.target as HTMLSelectElement;
    this.selectedTerrain = target.value;
    this.checkDataAvail()
  }
  closeModal() {
    this.currentStep = 1
    this.form.reset({
      application: '',
      terrain: '',
      vehicles: 1,
      model: this.productDetailList.model,
      range1: '',
      range2: ''
    });
    this.selectedTerrain = '';
    // this.form.reset()
    this.terrainvalue = false
  }

 async nextStep(data) {
    if (this.currentStep <= 3) {
      this.applicationAMC();
      this.currentStep += 1;
      event.preventDefault();
      if (this.productDetailList.lob == "HCV Const") {
        if ((this.productDetailList.lob == 'HCV Const' && this.productDetailList.pl == 'SIGNA 4830.TK.') || (this.productDetailList.lob == 'HCV Const' && this.productDetailList.pl == 'SIGNA 4830.TK. FBV') || (this.productDetailList.lob == 'HCV Const' && this.productDetailList.pl == 'SIGNA 4825.TK.') || (this.productDetailList.lob == 'HCV Const' && this.productDetailList.pl == 'SIGNA 4230.TK.')) {
          this.isHCV = false
        } else {
          this.isHCV = true
        }
      } else {
        this.isHCV = false
      }

    }
    if (data == true) {
      try {
        await this.vastatrequestresponse(); // Wait for API response
      } catch (error) {
        console.error("Error in vastatrequestresponse:", error);
      }
    } 
  }

  BookingVas() {
    try {
      // this.spinner.show()
      let data = {
        arn: 'None',
        region: '',
        state: this.userData ? this.userData.state : '',
        city: this.userData ? this.userData.city : '',
        vc_number: this.productDetailList.vehicle_number,
        lob: this.productDetailList.lob,
        ppl: this.productDetailList.ppl,
        pl: this.productDetailList.pl,
        emission_standard: "BS6 PH-II",
        // this.productDetailList.emission_norms,
        body_type: this.productDetailList?.body_type ? this.productDetailList?.body_type : 'None',
        fuel_type: this.productDetailList.fuel_type,
        payload: this.productDetailList.payload,
        number_of_chassis_to_enroll: this.form.controls['vehicles'].value ? this.form.controls['vehicles'].value : '1',
        vehicle_application: this.form.controls['application'].value.display_application,
        chassis_to_enroll: 'None',
        average_monthly_km: this.productDetailList.lob !== 'HCV Const' || (this.productDetailList.lob == 'HCV Const' && this.productDetailList.pl == 'SIGNA 4830.TK.') || (this.productDetailList.lob == 'HCV Const' && this.productDetailList.pl == 'SIGNA 4830.TK. FBV') || (this.productDetailList.lob == 'HCV Const' && this.productDetailList.pl == 'SIGNA 4825.TK.') || (this.productDetailList.lob == 'HCV Const' && this.productDetailList.pl == 'SIGNA 4230.TK.')
          ? Math.floor(this.form.controls['range1'].value / 12) : '',
        average_monthly_hours: (this.productDetailList.lob == 'HCV Const' && this.productDetailList.pl == 'SIGNA 4830.TK') || (this.productDetailList.lob == 'HCV Const' && this.productDetailList.pl == 'SIGNA 4830.TK. FBV') || (this.productDetailList.lob == 'HCV Const' && this.productDetailList.pl == 'SIGNA 4825.TK') || (this.productDetailList.lob == 'HCV Const' && this.productDetailList.pl == 'SIGNA 4230.TK') ? "" : this.productDetailList.lob == 'HCV Const' ? Math.floor(this.form.controls['range1'].value / 12) : '', customer_tml_fleet_size: 'None',
        contract_duration: Math.floor(this.form.controls['range2'].value.toString() / 12),
        terrain: this.form.controls['terrain'].value,
        key_account: 'No',
        cust_previous_vas_hist_by_no_of_chassis: 'None',
      };
      this.vas_configurator_request = data
      this.apiService.AmcWraperData(data)
        .subscribe({
          next: (response: any) => {
            this.vas_configurator_response = response;
            if ((response.success && Object.keys(response.data.vas_recommendation)?.length > 0) && (this.productDetailList.lob == 'HCV Cargo' || this.productDetailList.lob == 'HCV Const'|| this.productDetailList.lob == 'LCV' || this.productDetailList.lob == 'MCV Trucks' || this.productDetailList.lob == 'ICV Trucks')) {
              this.spinner.hide()
              this.amcproductData = [response?.data.vas_recommendation]
              const vasRecommendation = response?.data?.vas_recommendation || {};
              this.amcDataArray = Object.keys(vasRecommendation).map((key) => {
                let extendedData = {
                  amcDataArray: this.amcDataArray,
                  isHcv: this.isHCV
                }
                if ((this.datadismiss == true) && (this.productDetailList.lob == 'HCV Const' || this.productDetailList.lob == 'HCV Cargo' || this.productDetailList.lob == 'LCV' || this.productDetailList.lob == 'MCV Trucks' || this.productDetailList.lob == 'ICV Trucks')) {
                  localStorage.setItem('extendedVas', JSON.stringify(extendedData))
                }
                return { ...vasRecommendation[key] };
              });
              // this.nextStep()
              this.datadismiss = true
            } else {
              this.datadismiss = false

              // this.goToamc();
            }
          },
          error: (err) => {
            this.spinner.show()
            if (err.name === 'TimeoutError') {
              console.error('Request timed out.');
            } else {
              console.error('API call failed', err);
            }
            this.invalidReq = true;

          }
        });
    } catch (error) {
      this.spinner.show()
    }
  }

  getPlanImage(value): string {
    let plan = value || ''; // Get the plan or an empty string
    return '../../../assets/images/' + plan?.toLowerCase()
      .replace(/\s+/g, '_')
      .trim()
      + '.png'; // Generate the image path
  }

  numberofVehicleEvent(event: any) {
    this.form.controls['terrain'].setValue('');
    this.form.controls['application'].setValue('');
  }
  calculateTotalAmount(data: any): number {
    return data.reduce((sum, service) => {
      const contractYears = service['contract years'] ? service['contract years'] : 1;
      const chasis = service['number_of_chassis'] ? service['number_of_chassis'] : 1;
      return sum + ((service.price_per_year * contractYears) * chasis);
    }, 0);
  }

  calculateTotalAmountperyear(data: any) {
    return data.reduce((sum, service) => {
      return sum + (service.price_per_year);
    }, 0);
  }

  getSchemeDetail(vc: string): void {
    try {
      let data = {
        vc,
        "visibility": "web"
      };

      this.sub.add(
        this.apiService.getSchemeDetails(data).subscribe({
          next: (res: any) => {
            if (res?.data) {
              this.schemeDetailList = res.data;
            } else {

            }
          },
          error: (err) => {

          }
        })
      );

    } catch (error) {

    }
  }
  vastatrequestresponse(data?){
    //   let Payload = {
    //     "id": "",
    //     "home_configurator_request": this.vas_configurator_request ? this.vas_configurator_request : '',
    //     "home_configurator_response": this.vas_configurator_response ? this.vas_configurator_response:'' ,
    //     "osp_configurator_vas_filter_request":this.osp_configurator_request ? this.osp_configurator_request : '',
    //     "osp_configurator_vas_filter_response":this.osp_configurator_response ? this.osp_configurator_response : '',
    //     "request_id": "",
    //     "vehicle_number":"",
    //     "model": "",
    //     "number_of_vehicles": this.form.controls['vehicles'].value,
    //     "application": this.form.controls['application'].value.actual_application,
    //     "terrain": this.form.controls['terrain'].value,
    //     "annual_runnig": this.form.controls['range1'].value.toString(),
    //     "duration_of_amc":this.form.controls['range2'].value.toString(),
    //     "vas_offer": "",
    //     "amc": "",
    //     "fms": "",
    //     "ew": "",
    //     "oss": "",
    //     "fleetedge": "",
    //     "uptime_guarantee": "",
    //     "source": ""
    //   };
    // this.spinner.show();
    //   try {
    //     this.sub.add(
    //       this.apiService.getvastat(Payload).subscribe({
    //         next: (res: any) => {
    //           if (res?.success) {
    //            this.spinner.hide();
    //            if(res?.data?.id){
    //             localStorage.removeItem('tat_id');
    //             localStorage.setItem('tat_id',res?.data?.id);
    //             }
    //           } else {
    //             this.spinner.hide();
    
    //           }
    //         },
    //         error: (error: any) => {
    //           this.spinner.hide();
    
    //         },
    //         complete: () => {
    //           this.spinner.hide();
    //         }
    //       })
    //     );
    //   } catch (error) {
    //     this.spinner.hide();
    
    //   }
    
      return new Promise((resolve, reject) => {
        let Payload = {
          "id": "",
          "home_configurator_request": this.vas_configurator_request ? this.vas_configurator_request : '',
          "home_configurator_response": this.vas_configurator_response ? this.vas_configurator_response:'' ,
          "osp_configurator_vas_filter_request":this.osp_configurator_request ? this.osp_configurator_request : '',
          "osp_configurator_vas_filter_response":this.osp_configurator_response ? this.osp_configurator_response : '',
          "request_id": "",
          "vehicle_number":"",
          "model": "",
          "number_of_vehicles": this.form.controls['vehicles'].value ? Number(this.form.controls['vehicles'].value) : 0,
          "application": this.form.controls['application'].value.actual_application,
          "terrain": this.form.controls['terrain'].value,
          "annual_runnig": this.form.controls['range1'].value.toString(),
          "duration_of_amc":this.form.controls['range2'].value.toString(),
          "vas_offer": "",
          "amc": "",
          "fms": "",
          "ew": "",
          "oss": "",
          "fleetedge": "",
          "uptime_guarantee": "",
          "source": "",
          "vas_booking_price":"",
        };
    
        this.spinner.show();
    
        this.apiService.getvastat(Payload).subscribe({
          next: (res: any) => {
            this.spinner.hide();
            if (res?.success) {
              if(res?.data?.id){
                localStorage.removeItem('tat_id');
                localStorage.setItem('tat_id',res?.data?.id);
                }
              resolve(res);
            } else {
              reject("API call failed.");
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            reject(error);
          },
          complete: () => {
            this.spinner.hide();
          }
        });
      });
    
    }
  vastatrequestresponsereturn(data?): Promise<any> {
    return new Promise((resolve, reject) => {
      let id = localStorage.getItem('tat_id');
      let vasData = this.localStorage.getItem('VASData');
      let parsedData = vasData ? JSON.parse(vasData) : {}; 
      console.log(parsedData);
      let vasOffer = "";
  let vasBookingPrice = "";
  
  if (Array.isArray(parsedData?.VASPLAN) && parsedData.VASPLAN.length > 0) {
      vasOffer = parsedData.VASPLAN[0].plan || "";
      vasBookingPrice = parsedData.VASPLAN[0].price_per_year ? `${(Math.round(parsedData.VASPLAN[0].price_per_year) * (parsedData.VASPLAN[0]['contract years'] || 1)) * (parsedData.VASPLAN[0].number_of_chassis || 1)}` : "";
  }
      let Payload = {
        "id": id ? id : '',
        "home_configurator_request": this.vas_configurator_request || '',
        "home_configurator_response": this.vas_configurator_response || '',
        "osp_configurator_vas_filter_request": this.osp_configurator_request || '',
        "osp_configurator_vas_filter_response": this.osp_configurator_response || '',
        "request_id": "",
        "vehicle_number": this.productDetailList?.vehicle_number,
        "model": this.productDetailList?.model,
        "number_of_vehicles": this.form.controls['vehicles'].value ? Number(this.form.controls['vehicles'].value) : 0,
        "application": this.form.controls['application'].value.actual_application,
        "terrain": this.form.controls['terrain'].value,
        "annual_runnig": this.form.controls['range1'].value.toString(),
        "duration_of_amc": this.form.controls['range2'].value.toString(),
        "vas_offer": vasOffer ? vasOffer : '',
          "amc": "",
          "fms": "",
          "ew": this.getPlanPrice('Extended Warranty'), 
          "oss": "",
          "fleetedge": this.getPlanPrice('ADVANCE FLEETEDGE'), 
          "uptime_guarantee": this.getPlanPrice('Uptime Guarantee'),  
          "source": "",
          "vas_booking_price":vasBookingPrice ? vasBookingPrice :'',
      };

      this.spinner.show();

      this.apiService.getvastat(Payload).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          if (res?.success) {

            resolve(res);
          } else {
            reject("API call failed.");
          }
        },
        error: (error: any) => {
          this.spinner.hide();
          reject(error);
        },
        complete: () => {
          this.spinner.hide();
        }
      });
    });
  }

  gotorewardtermscondition(row: any) {
    const data = row.scheme_master;
    this.localStorage.setItem('rewardTermsCondition', JSON.stringify(data));
    this.localStorage.setItem('currentRoute', this.currentRoute);
    this.router.navigate(['/reward-terms-condition'], {
      queryParams: { id: this.productId }
    });
  }
  getPlanPrice(planName: string): string {
    let vasData = this.localStorage.getItem('VASData');
    let parsedData = vasData ? JSON.parse(vasData) : {};
  
    // Ensure VASPLAN exists and has at least two elements (ignoring 0th position)
    if (!Array.isArray(parsedData?.VASPLAN) || parsedData.VASPLAN.length === 0) {
        return "";
    }
  
    // Find the matching plan but skip the first element (VASPLAN[0])
    const plan = parsedData.VASPLAN.slice(1).find(item => item.plan?.toUpperCase() === planName.toUpperCase());
  
    if (plan && Number.isFinite(plan.price_per_year) && Number.isFinite(plan["contract years"])) {
      return `${(Math.round(plan.price_per_year * plan["contract years"])* plan.number_of_chassis)}`;
    }
  
    return "";
  }

 loadScript(): void {  
    if (isPlatformBrowser(this.platformId)) {
    if (this.isChatbotLoaded) {
      if (window['toggleChatbox']) {
        window['toggleChatbox']();
      } else {
        console.error('toggleChatbox function is not defined.');
      }
      return;
    }
  
    const script = this.renderer.createElement('script');
    script.src = 'assets/finalchatbot_osp/newChatbot.js';
  
    script.onload = () => {
      console.log("Chatbot script loaded successfully.");
  
      if (window['initializeChatbot']) {
        const sessionId = localStorage.getItem('sessionId') || 'defaultSession';
        window['initializeChatbot'](sessionId);
        
        this.isChatbotLoaded = true;
        if (window['toggleChatbox']) {
          window['toggleChatbox']();
        } else {
          console.error('toggleChatbox function is not defined.');
        }
      } else {
        console.error('initializeChatbot function is not defined.');
      }
    };
  
    script.onerror = () => {
      console.error('Error loading chatbot script.');
    };
  
    this.renderer.appendChild(document.body, script);
   }
  }
    ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
